import axios from 'axios';
import { API_BASE_URL } from '../utils/constants';

const api = axios.create({
  baseURL: `${API_BASE_URL}/contacts`,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('authToken');
    if (token) {
      config.headers.Authorization = `Token ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('authToken');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export const contactService = {
  // --- Contacts ---
  getAll: async (params = {}) => {
    const response = await api.get('/list/', { params });
    return response.data;
  },
  getById: async (id) => {
    const response = await api.get(`/list/${id}/`);
    return response.data;
  },
  create: async (data) => {
    const response = await api.post('/list/', data);
    return response.data;
  },
  update: async (id, data) => {
    const response = await api.patch(`/list/${id}/`, data);
    return response.data;
  },
  delete: async (id) => {
    const response = await api.delete(`/list/${id}/`);
    return response.data;
  },

  // --- Applicants ---
  getApplicants: async () => {
    const response = await api.get('/applicants/');
    return response.data;
  },
  createApplicant: async (data) => {
    const response = await api.post('/applicants/', data);
    return response.data;
  },

  // --- Vendors ---
  getVendors: async () => {
    const response = await api.get('/vendors/');
    return response.data;
  },
  createVendor: async (data) => {
    const response = await api.post('/vendors/', data);
    return response.data;
  },

  // --- Landlords ---
  getLandlords: async () => {
    const response = await api.get('/landlords/');
    return response.data;
  },
  createLandlord: async (data) => {
    const response = await api.post('/landlords/', data);
    return response.data;
  },

  // --- Identity Checks ---
  getIdentityChecks: async (contactId = null) => {
    const params = contactId ? { contact: contactId } : {};
    const response = await api.get('/identity-checks/', { params });
    return response.data;
  },
  createIdentityCheck: async (data) => {
    const response = await api.post('/identity-checks/', data);
    return response.data;
  },
  updateIdentityCheck: async (id, data) => {
    const response = await api.patch(`/identity-checks/${id}/`, data);
    return response.data;
  },
  deleteIdentityCheck: async (id) => {
    const response = await api.delete(`/identity-checks/${id}/`);
    return response.data;
  },
};
